import { FC } from 'react';
import { DailyLogInput, Question as Q } from '../../../graphql/generated/graphql.ts';
import { Divider, Stack, Typography } from '@mui/material';
import { SubmitButton } from '../../../components/forms/submit.button.tsx';
import { Question } from '../../../components/question/question.tsx';
import { DeepPartial } from '@apollo/client/utilities';
import { Form, Formik } from 'formik';
import * as yup from 'yup';

export interface QuestionsProps {
  questions: DeepPartial<Q[]>;
  onNext: (input: Partial<DailyLogInput>) => void;
  DAY?: string;
  skipActivityReport: boolean;
}

export const Questions: FC<QuestionsProps> = ({ questions, onNext, DAY, skipActivityReport }) => {
  return (
    <>
      <Formik
        validationSchema={yup.object(
          questions.reduce((acc: any, question: any) => {
            acc[question._id] = yup.string().required('Required');
            return acc;
          }, {})
        )}
        initialValues={{}}
        onSubmit={(values: any) => {
          onNext({
            questions:
              Object.keys(values).map((questionID: string) => ({
                questionID,
                answer: values[questionID].toString()
              })) || [],
            activities: []
          });
        }}
      >
        <Form>
          {questions.map((question: any, index) => (
            <Stack key={question._id} spacing={2}>
              <Question question={question} DAY={DAY} />
              {index !== questions.length && <Divider />}
            </Stack>
          ))}
          {questions.length === 0 && (
            <Stack spacing={2} sx={{ mt: 2 }}>
              <Typography>No questions available for this daily log.</Typography>
            </Stack>
          )}
          <SubmitButton>{skipActivityReport ? 'Save' : 'Next'}</SubmitButton>
        </Form>
      </Formik>
    </>
  );
};
